import URLConfig from '@Config/urls/url.config';
import { Route } from 'react-router-dom';
import * as AdminUsersModulePages from '@Modules/admin/users/pages';

const adminUsersRoutes = [
  <Route
    path={URLConfig.ADMIN.USERS.PROFILE}
    element={<AdminUsersModulePages.UsersProfile />}
  />,
  <Route
    path={URLConfig.ADMIN.USERS.PROFILE_OPTION_MODULE}
    element={<AdminUsersModulePages.ProfileOptionModule />}
  />,
  <Route
    path={URLConfig.ADMIN.USERS.USERS_MANAGMENT}
    element={<AdminUsersModulePages.UsersManagement />}
  />,
  <Route
    path={URLConfig.ADMIN.USERS.PASSWORD_SETTINGS}
    element={<AdminUsersModulePages.PasswordSettings />}
  />,
  <Route
    path={URLConfig.ADMIN.USERS.USERS_SUPERVISION}
    element={<AdminUsersModulePages.UsersSupervision />}
  />,
  <Route
    path={URLConfig.ADMIN.USERS.CONSULTATION_LOG_FILE}
    element={<AdminUsersModulePages.ConsultationLogFile />}
  />,
  <Route
    path={URLConfig.ADMIN.USERS.PURGE_LOG_FILE}
    element={<AdminUsersModulePages.PurgeLogFile />}
  />,
  <Route
    path={URLConfig.ADMIN.USERS.SENSIBLE_DATA_LOG}
    element={<AdminUsersModulePages.SensibleDataLog />}
  />,
];

export default adminUsersRoutes;
